import React, { useState, useEffect } from 'react';
import { Table, Pagination, Checkbox } from 'antd';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { set } from 'immutable';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { Input } from 'antd';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { useForm, Controller, Feedback } from 'react-hook-form';




import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import { URL_EMPLOYEE } from '../../constans/servidor';
import PaginationComponent from './pagination';





// const columns = [
//     {
//         title: 'Parqueadero',
//         dataIndex: 'nombre_park',
//     },
//     {
//         title: 'Terminal',
//         dataIndex: 'cod_terminal'
//     },
//     {
//         title: 'Placa',
//         dataIndex: 'placa',
//     },
//     {
//         title: 'Estado',
//         dataIndex: 'estado',
        
//     },
//     {
//         title: 'Codigo Parqueadero',
//         dataIndex: 'cod_park',
//     },
//     {
//         title: 'Fecha/Hora',
//         dataIndex: 'fecha_hora',
//     }
// ];


const TablePComponent = props => {
    const { data, datos } = props;
    const [loadingData, setLoadingData] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [placa, setPlaca] = useState();
    const [placass, setPlacass] = useState();
    const [estado, setEstado] = useState(0);
    const [fecha_hora, setFecha_hora] = useState();
    const [cod_terminal, setCod_terminal] = useState();
    const [cod_park, setCod_park] = useState();
    const [modal, setModal] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterData, setFilterData] = useState([]);
    const [dataPagination, setDataPagination] = useState([]);
    const [dplaca,setdPlaca]= useState([]);
    const [dplaca1,setdPlaca1]= useState([]);



    useEffect(() => {
        setFilterData(data);
        setTimeout(() => {
            setEstado(1)
        }, 800);
    }, [data]);
    let handleSearch=''
    let handleRowClick=''
    let filteredData=''
    // let dplaca=[]
    
        
        handleSearch = (event) => {
          setSearchTerm(event.target.value);
        };
      
        handleRowClick = (row) => {
          const isSelected = selectedRows.includes(row);
          setSelectedRows(isSelected
            ? selectedRows.filter((selectedRow) => selectedRow !== row)
            : [...selectedRows, row]
          );
          if (!dplaca.includes(row.placa)) { // verificamos si la placa ya existe en la lista
            const newDplaca = [...dplaca, row.placa]; // Creamos una nueva lista con la placa agregada
            setdPlaca(newDplaca);
            setdPlaca1("-" + newDplaca + " ");
          }
          setCod_terminal(row.nombre_park)
          setCod_park(row.park)

        };
      
        filteredData = dataPagination.filter((row) =>
          Object.values(row).some((value) =>
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
    
  
    return (
      <>

      {data ? (
        <>
        <Row className="justify-content-end" >
        <input className='buscar' type="text" placeholder="Search..." onChange={handleSearch} />
            </Row>
        <table className='tabla'>
          <thead>
            <tr>
              <th></th>
              <th>Parqueadero</th>
              <th>Terminal</th>
              <th>Placa</th>
              <th>Cod de Parqueadero</th>
              <th>Contrato</th>
              <th>Fecha/Hora</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((row) => (
              <tr key={row.id} onClick={() => handleRowClick(row)}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row)}
                    onChange={() => handleRowClick(row)}
                  />
                </td>
                <td>{row.nombre_park}</td>
                <td>{row.cod_terminal}</td>
                <td>{row.placa}</td>
                <td>{row.cod_park}</td>
                <td>{row.contrato}</td>
                <td>{row.fecha_hora}</td>

              </tr>
            ))}
          </tbody>
        </table>
        <div className="float-right pagination">
                                <PaginationComponent
                                    data={data}
                                    setDataPagination={setDataPagination}
                                    title="Posts"
                                    pageLimit={2}
                                    dataLimit={100}
                                />
                            </div>
            <p>{dplaca1}</p>
        </>
      ) : null}
        </>

    );
  };
  

export default TablePComponent;
